import { categoryMeta } from './notificationMeta';

const CategoryIcon = ({ category, size = 36 }) => {
  const meta = categoryMeta(category);
  const Icon = meta.icon;
  return (
    <span
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        borderRadius: size / 3.2,
        background: meta.bg,
        color: meta.color,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <Icon size={Math.round(size * 0.47)} strokeWidth={2} />
    </span>
  );
};

export default CategoryIcon;
